if (!customElements.get("video-component")) {
  customElements.define(
    "video-component",
    class VideoComponent extends HTMLElement {
      constructor() {
        super();
        this.bindEvents();
      }

      bindEvents() {
        this.querySelector("button.sound-toggle").addEventListener(
          "click",
          this.handleClick.bind(this),
        );
      }

      handleClick(e) {
        e.preventDefault();
        this.videoEl = this.querySelector("video");
        this.videoEl.muted = !this.videoEl.muted;
        this.querySelector("button.sound-toggle").classList.toggle("sound-on");
      }
    },
  );
}
